import React from "react";
import { Button, Pagination, Searchbox, Table, Badge, Toast, Dialog, Container } from "../../../../../../Components";
import { useState } from "react";
import { apis, deleteRequest, post } from "../../../../../../Utils/axios";
import moment from "moment";
import useFetch from "../../../../../../Hooks/useFetch";

function Invitations() {
	const initial = {
		invitations: [],
		count: 0,
		pages: 0,
	};
	const [Query, setQuery] = useState({
		search: "",
		page: 1,
	});

	const { response, loading, reload } = useFetch(apis.getInvitedUsers, Query, initial);
	const [ConfirmDialog, setConfirmDialog] = useState();
	const [InviteSent, setInviteSent] = useState();

	const onRevoke = () => {
		deleteRequest(`/invitations/${ConfirmDialog.id}`, {}, (r, e) => {
			if (r) {
				Toast.success("Invitation Revoked");
				setConfirmDialog();
				reload();
			} else if (e) {
				console.log(e);
				Toast.handleError(e);
			}
		});
	};

	const resendInvite = (invite) => {
		if (InviteSent === invite.id) return;

		post(`/invitations/${invite.id}/resend`, {}, (r, e) => {
			if (r) {
				Toast.success("Sent a new invitation");
				setConfirmDialog();
				setInviteSent(invite.id);
			} else if (e) {
				console.log(e);
				Toast.handleError(e);
			}
		});
	};

	return (
		<>
			<div className="mt-6 flex-center-between">
				<div className="align-center">
					<Searchbox placeholder="Search by email" cmd="s" onChange={(search) => setQuery({ ...Query, search })} />
				</div>
			</div>
			<Container variant="outlined" className="!p-0 mt-4">
				<Table
					loading={loading}
					className="rounded-md"
					nodes={response.invitations.map((invite) => ({
						email: invite.email,
						status: <Badge variant="warning">Pending</Badge>,
						createdAt: moment(invite.updatedAt).format("DD MMM YYYY"),
						actions: (
							<div className="flex gap-2">
								<Button onClick={() => resendInvite(invite)} variant={InviteSent === invite.id ? "success" : "outlined"} className="btn-xs">
									{InviteSent === invite.id ? "Sent !!" : "Resend Invite"}
								</Button>
								<Button onClick={() => setConfirmDialog(invite)} variant="danger" className="btn-xs">
									Revoke
								</Button>
							</div>
						),
					}))}
					headers={[
						{ key: "email", label: "Email" },
						{ key: "status", label: "Status" },
						{ key: "createdAt", label: "Invited On" },
						{ key: "actions", label: "Actions" },
					]}
				/>
			</Container>
			<div className="flex justify-end mt-4">
				<Pagination active={Query.page} total={response.pages} onChange={(page) => setQuery({ ...Query, page })} />
			</div>
			<Dialog variant="danger" open={ConfirmDialog} title="Revoke User Invitation" description="Are you sure you want to revoke this invite." submitLabel="Delete" onSubmit={onRevoke} onClose={setConfirmDialog} />
		</>
	);
}

export default Invitations;
